import { render } from "./LoadingSpinnerNr4.vue?vue&type=template&id=6078df5a&scoped=true"
import script from "./LoadingSpinnerNr4.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr4.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr4.vue?vue&type=style&index=0&id=6078df5a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6078df5a"]])

export default __exports__